import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { VerificationServiceChangeRequest } from "@idw-types/data/verification-service";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";

type SubmitVerificationServiceChangeRequestModalProps = {
    serviceName: string;
    apiKey: string;
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<VerificationServiceChangeRequest>;
};

export const SubmitVerificationServiceChangeRequestModal = (props: SubmitVerificationServiceChangeRequestModalProps) => {
    const { serviceName, apiKey, onModalClose, onSubmitHandler } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>This action will <b>SUBMIT</b> the Change Request for the Verification Service 
                    named <b>{serviceName}</b> with API Key <b>{apiKey}</b> for review.</p>
                <p>
                    After the Change Request has been reviewed, it will either be APPROVED or returned to an UNSUBMITTED status for corrections or modifications.
                    You may UNSUBMIT this Change Request at any time prior to completion of the review process if you would like to make changes.
                    You may also CANCEL the Change Request at any time prior to deployment using the CANCEL option.
                </p>
            </div>
        );
    }, []);

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.SUBMIT}
            title={"Submit Verification Service Change Request for Review"}
            body={bodyElement}
            buttonText={"Submit Change Request"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};